import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, patch, post, put } from "helpers/api_helper"
import {
  ADD_LOYALTY_POINTS,
  APP_VERSIONS,
  CUSTOMER_LOYALTY_POINTS,
  DELETE_CUSTOMER,
  GET_ALL_CUSTOMERS,
  GET_CUSTOMERS_LIST,
  GET_CUSTOMER_DETAILS,
  PAYMENT_HISTORY,
  REVOKE_LOYALTY_POINTS,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_STATUS,
  WALLET_HISTORY,
} from "helpers/url_helper"

export const getAllCustomers = createAsyncThunk(
  GET_ALL_CUSTOMERS,
  async payload => {
    const response = await post(GET_ALL_CUSTOMERS, payload)
    return response
  }
)

export const getAllCustomersList = createAsyncThunk(
  GET_CUSTOMERS_LIST,
  async payload => {
    const response = await post(GET_CUSTOMERS_LIST, payload)
    return response
  }
)

export const getBlackListCustomers = createAsyncThunk(
  "BLACK_LIST_CUSTOMERS",
  async payload => {
    const response = await post(GET_ALL_CUSTOMERS, payload)
    return response
  }
)

export const updateCustomerStatus = createAsyncThunk(
  UPDATE_CUSTOMER_STATUS,
  async payload => {
    const response = await patch(UPDATE_CUSTOMER_STATUS, payload)
    return response
  }
)

export const restoreCustomer = createAsyncThunk(
  "RESTORE_CUSTOMER",
  async payload => {
    const response = await patch(UPDATE_CUSTOMER_STATUS, payload)
    return response
  }
)

export const getCustomerDetails = createAsyncThunk(
  GET_CUSTOMER_DETAILS,
  async payload => {
    const response = await post(GET_CUSTOMER_DETAILS, payload)
    return response
  }
)

export const deleteCustomer = createAsyncThunk(
  DELETE_CUSTOMER,
  async payload => {
    const response = await del(DELETE_CUSTOMER, payload)
    return response
  }
)

export const updateCustomer = createAsyncThunk(
  UPDATE_CUSTOMER,
  async payload => {
    const response = await put(UPDATE_CUSTOMER, payload)
    return response
  }
)

export const getCustomerLoyaltyPoints = createAsyncThunk(
  CUSTOMER_LOYALTY_POINTS,
  async payload => {
    const response = await post(CUSTOMER_LOYALTY_POINTS, payload)
    return response
  }
)

export const addLoyaltyPoints = createAsyncThunk(
  ADD_LOYALTY_POINTS,
  async payload => {
    const response = await post(ADD_LOYALTY_POINTS, payload)
    return response
  }
)

export const revokeLoyaltyPoints = createAsyncThunk(
  REVOKE_LOYALTY_POINTS,
  async payload => {
    const response = await post(REVOKE_LOYALTY_POINTS, payload)
    return response
  }
)

export const getPaymentHistory = createAsyncThunk(
  PAYMENT_HISTORY,
  async payload => {
    const response = await post(PAYMENT_HISTORY, payload)
    return response
  }
)

export const getWalletHistory = createAsyncThunk(
  WALLET_HISTORY,
  async payload => {
    const response = await post(WALLET_HISTORY, payload)
    return response
  }
)

export const getAppVersions = createAsyncThunk(APP_VERSIONS, async payload => {
  const response = await post(APP_VERSIONS, payload)
  return response
})
